export default __webpack_public_path__ + "static/18-b24b7b86e301ee9ce798ce432c01c817.jpg";